export default {
    required: "required",
    optional: "optional",
    selectOne: "selectOne",
    unavailable: "unavailable",
};
